<div class="hotel-stay-calendar">
  <div class="hotel-stay-calendar__fields">
    <button type="button" [class.active]="activeField === 'checkIn'" (click)="selectField('checkIn')">
      <span>{{ labels.checkIn }}</span>
      <strong>{{ dateFrom | date:'d MMMM' }}</strong>
    </button>
    <button type="button" [class.active]="activeField === 'checkOut'" (click)="selectField('checkOut')">
      <span>{{ labels.checkOut }}</span>
      <strong>{{ dateTo | date:'d MMMM' }}</strong>
    </button>
  </div>
  <div class="hotel-stay-calendar__months" #monthsScroller (touchstart)="$event.stopPropagation()">
    @for (month of months; track month.date) {
      <section class="hotel-stay-calendar__month" [attr.data-month]="month.date | date:'yyyy-MM'">
        <h3>{{ month.date | date:'LLLL yyyy' }}</h3>
        <div class="hotel-stay-calendar__grid">
          @for (cell of month.cells; track $index) {
            @if (cell.key) {
              <button type="button" [disabled]="!canSelect(cell.key)"
                      [class.selected]="cell.key === dateFrom || cell.key === dateTo"
                      [class.range-start]="cell.key === dateFrom"
                      [class.range-end]="cell.key === dateTo"
                      [class.in-range]="cell.key > dateFrom && cell.key < dateTo"
                      [attr.aria-label]="cell.key | date:'d MMMM yyyy'"
                      [attr.aria-pressed]="cell.key === dateFrom || cell.key === dateTo"
                      (click)="selectDate(cell.key)">{{ cell.day }}</button>
            } @else {
              <span></span>
            }
          }
        </div>
      </section>
    }
    <button type="button" class="hotel-stay-calendar__more" (click)="loadMore()">{{ labels.more }}</button>
  </div>
</div>
